import { render } from "./Headernav.vue?vue&type=template&id=50899cd1&scoped=true"
import script from "./Headernav.vue?vue&type=script&lang=js"
export * from "./Headernav.vue?vue&type=script&lang=js"

import "./headernav.scss?vue&type=style&index=0&id=50899cd1&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50899cd1"]])

export default __exports__